import * as React from "react";

import { track } from "../../analytics";
import styled from "../../styled-components";
import { media } from "../../breakpoints";

const Footer = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.white};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 40px 40px;

  ${media.TABLET`
    flex-direction: column;
    padding: 0 20px 10px;
  `};
`;

const PressLinks = styled.div`
  font-size: 12px;
  margin-top: 20px;
  display: flex;
  justify-content: center;

  ${media.TABLET`
    font-size: 11px;
    order: 1;
    text-align: center;
    flex-wrap: wrap;
    justify-content: center;
  `};
`;

const PressLink = styled.a`
  color: ${props => props.theme.colors.black};
  margin: 0 10px;
  text-decoration: none;
  text-transform: capitalize;
  ${media.TABLET`
    margin: 10px;
  `};
`;

const NewTag = styled.span`
  padding: 3px 5px;
  border-radius: 100px;
  position: relative;
  top: -1px;
  background: tomato;
  color: #fff;
  font-size: 9px;
`;

export interface IIndexFooterProps {
  footerLogoAsProp?: JSX.Element;
}

const IndexFooter: React.SFC<IIndexFooterProps> = props => {
  const handleElementClick = (publisher: string) => {
    track("Press Article Clicked", { publisher });
  };

  return (
    <Footer>
      <PressLinks>
        <PressLink
          href="https://finance.yahoo.com/news/say-app-tesla-shareholder-vote-on-questions-elon-musk-175701142.html"
          target="_blank"
          onClick={event => handleElementClick("yahoo finance")}
        >
          Yahoo Finance <NewTag>New</NewTag>
        </PressLink>
        <PressLink
          href="https://news.bloomberglaw.com/corporate-law/teslas-once-boring-earnings-q-a-opens-up-to-small-holders-1"
          target="_blank"
          onClick={event => handleElementClick("bloomberg law")}
        >
          Bloomberg Law <NewTag>New</NewTag>
        </PressLink>
        <PressLink
          href="https://cheddar.com/media/tech-start-up-say-is-bridging-the-gap-between-shareholders-and-companies"
          target="_blank"
          onClick={event => handleElementClick("cheddar")}
        >
          Cheddar <NewTag>New</NewTag>
        </PressLink>
        <PressLink
          href="https://www.youtube.com/channel/UC1LAjODfg7dnSSrrPGGPPMw"
          target="_blank"
          onClick={event => handleElementClick("hyperchange")}
        >
          Hyperchange TV
        </PressLink>

        <PressLink
          href="https://www.cnbc.com/2019/01/30/this-time-tesla-will-take-questions-from-regular-investors.html"
          target="_blank"
          onClick={event => handleElementClick("cnbc")}
        >
          CNBC <NewTag>New</NewTag>
        </PressLink>
        <PressLink
          href="https://www.forbes.com/sites/donnafuscaldo/2019/02/19/say-gives-retail-investors-a-voice-and-tesla-listens/"
          target="_blank"
          onClick={event => handleElementClick("forbes")}
        >
          Forbes
        </PressLink>
        <PressLink
          href="https://www.barrons.com/articles/proxy-voting-is-broken-and-needs-to-change-1530924318"
          target="_blank"
          onClick={event => handleElementClick("barrons")}
        >
          Barron's
        </PressLink>
        <PressLink
          href="http://www.businessinsider.com/we-talked-to-steve-cohens-right-hand-man-about-point72-ventures-latest-investment-tech-on-wall-street-and-cryptocurrency-2018-4"
          target="_blank"
          onClick={event => handleElementClick("business insider")}
        >
          Business Insider
        </PressLink>

        <PressLink
          href="https://nypost.com/2018/04/18/steve-cohen-is-plowing-into-fintech/"
          target="_blank"
          onClick={event => handleElementClick("ny-post")}
        >
          New York Post
        </PressLink>
      </PressLinks>
    </Footer>
  );
};

export default IndexFooter;



// WEBPACK FOOTER //
// ./src/pages/Index/IndexFooter.tsx